const fragShader = `
precision mediump float;

uniform float iTime;
uniform float intensity;
uniform float brightness;
uniform vec2 iResolution;
uniform vec3 waveColor;
uniform sampler2D iChannel0;
uniform sampler2D uMainSampler;
varying vec2 outTexCoord;
uniform vec2 uTextureCenter; // Новая uniform переменная для центра текстуры

#define time iTime*0.15
#define tau 6.2831853

mat2 makem2(in float theta) {
    float c = cos(theta);
    float s = sin(theta);
    return mat2(c, -s, s, c);
}

float noise(in vec2 x) {
    return texture2D(iChannel0, x * 0.01).x;
}

float fbm(in vec2 p) {
    float z = 2.0;
    float rz = 0.0;
    vec2 bp = p;
    for (float i = 1.0; i < 6.0; i++) {
        rz += abs((noise(p) - 0.5) * 2.0) / z;
        z = z * 2.0;
        p = p * 2.0;
    }
    return rz;
}

float dualfbm(in vec2 p) {
    vec2 p2 = p * 0.7;
    vec2 basis = vec2(fbm(p2 - time * 1.6), fbm(p2 + time * 1.7));
    basis = (basis - 0.5) * 0.2;
    p += basis;
    return fbm(p * makem2(time * 0.2));
}

float circ(vec2 p) {
    float r = length(p);
    r = log(sqrt(r));
    return abs(mod(r * 4.0, tau) - 3.14) * 3.0 + intensity;
}

void mainImage(out vec4 fragColor, in vec2 fragCoord) {
    vec4 startColor = texture2D(uMainSampler, outTexCoord);

    vec2 p = (outTexCoord * 2.0 - 1.0) * iResolution.y / iResolution.xy;
    p.y -= 1.0;
    p.x -= 1.0;
    p.x *= iResolution.x / iResolution.y;
    p *= 4.0;
    float rz = dualfbm(p);
    p /= exp(mod(time * 10.0, 3.14159));
    rz *= pow(abs((0.001 - circ(p))), 0.9);
    vec3 col = waveColor / rz * 4.0;
    col = pow(abs(col), vec3(0.99));
    fragColor = vec4((col.r + 0.90) * brightness, (col.g + 0.90) * brightness, (col.b + 0.90) * brightness, startColor.a) * startColor;
}

void main() {
    mainImage(gl_FragColor, gl_FragCoord.xy);
}
`;

export class GlowPipeline extends Phaser.Renderer.WebGL.Pipelines.SinglePipeline {
    constructor(game, color, delayFactor, intensity, brightness = 1.2) {
        super({
            game,
            fragShader,
            uniforms: ['iTime', 'iResolution', 'iChannel0', 'uMainSampler', 'uTextureCenter']
        });

        this.color = color;
        this.delayFactor = delayFactor;
        this.intensity = 1.9 - ((1.9 / 100) * intensity);
        this.brightness = brightness;
    }

    //  0.8, 0.5, 0.1 Yellow
    //  0.2, 0.1, 0.4 Blue

    onPreRender() {
        this.set1f('iTime', this.game.loop.time / this.delayFactor);
        this.set1f('intensity', this.intensity);
        this.set1f('brightness', this.brightness);
        this.set2f('iResolution', this.renderer.width, this.renderer.height);
        this.set3f('waveColor',this.color.x, this.color.y, this.color.z);
        this.set1i('iChannel0', 0);
        this.set2f('uTextureCenter', this.renderer.width, this.renderer.height);
    }
}
